import { Injectable, NgZone } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

// TODO: this service should be migrated to ep-ng
@Injectable()
export class BreakpointChangeService {
  private changes$: Observable<BreakpointChangeEvent>

  constructor(private ngZone: NgZone) {
    this.changes$ = fromEvent<[Event, BreakpointChangeEvent]>(jQuery('body'), 'breakpoint-change')
      .pipe(map(([event, changeEvent]) => ngZone.run(() => changeEvent)));
  }

  /**
   * Watches for breakpoint changes and returns true if
   * current view is equal to or below phone size
   * @return true if phone and below
   */
  public get isPhoneView$(): Observable<boolean> {
    return this.changes$.pipe(
      map((change: BreakpointChangeEvent) => change.current),
      startWith(Soho.breakpoints.current()),
      map(view => view === 'phone' || view === 'phonedown'),
      distinctUntilChanged()
    );
  }

  /**
   * Watches for breakpoint changes and returns true if
   * current view is greater than phone size
   * @return true if size is above phone
   */
  public get isAbovePhoneView$(): Observable<boolean> {
    return this.isPhoneView$.pipe(
      map(isPhoneView => !isPhoneView)
    );
  }
}

interface BreakpointChangeEvent {
  previous: string;
  current: string;
}
